import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Spinner } from '@/components/ui/spinner';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
interface AdsAndAdGroupsProps {
  campaignAds: Array<{
    id: number;
    slug: string;
    url: string;
    googleads_ad_group_id: string;
    funnel_stage?: string;
    negative_keywords?: Array<{
      googleads_ad_group_id: string;
      keyword: string;
      match_type?: string;
    }>;
  }>;
  isLoading: boolean;
  campaignId?: number;
  numericCampaignId: number | null;
  onAdClick: (adId: number) => void;
}

export const AdsAndAdGroups = ({ 
  campaignAds, 
  isLoading, 
  campaignId,
  onAdClick 
}: AdsAndAdGroupsProps) => {

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8 mb-4 bg-white rounded-md border">
        <Spinner />
        <span className="ml-2">Loading campaign ads...</span>
      </div>
    );
  }

  if (campaignAds.length === 0) {
    return (
      <div className="text-center p-8 bg-muted rounded-md mb-4">
        <p className="text-lg font-medium mb-2">No Ads Found</p>
        <p className="text-sm text-muted-foreground">
          No ads were found in this campaign.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <h3 className="text-sm font-medium">Ads and Ad Groups</h3>
          {campaignAds.length > 0 && (
            <Badge variant="outline">{campaignAds.length} total</Badge>
          )}
        </div>
      </div>

      <div className="rounded-md border mb-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Ad Group</TableHead>
              <TableHead>Ad URL</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {campaignAds.map((ad) => (
              <TableRow key={ad.id}>
                <TableCell className="font-medium">
                  <div className="flex items-center">
                    <div className="flex flex-col">
                      <button 
                        className="text-left text-blue-600 hover:underline truncate max-w-[150px] mr-2"
                        title={`Ad ID: ${ad.id}${ad.funnel_stage ? ` | Funnel: ${ad.funnel_stage}` : ''}`}
                        onClick={() => onAdClick(ad.id)}
                      >
                        {ad.googleads_ad_group_id}
                      </button>
                      {ad.funnel_stage && (
                        <span className="text-sm text-gray-500">
                          {ad.funnel_stage.replace('_funnel', '')}
                        </span>
                      )}
                    </div>
                    <Button 
                      variant="ghost" 
                      size="sm"
                      className="h-8 w-8 p-0"
                      onClick={() => window.open(`/campaigns/google/${campaignId}/ads/${ad.slug}`, '_blank')}
                    >
                      <ExternalLink className="h-4 w-4" />
                    </Button>
                  </div>
                </TableCell>
                <TableCell>
                  <span className="truncate max-w-[180px] inline-block" title={ad.url}>
                    {ad.url}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}; 